import angular from 'angular';

(function () {
    'use strict';
    angular.module('app.kissuser').factory('KissUserSvc', KissUserSvc);

    KissUserSvc.$inject = ['KissUserDA', 'SellersDA', 'WorkflowDA'];

    /* @ngInject */
    function KissUserSvc(KissUserDA, SellersDA, WorkflowDA) {
        var _userCreationData = null;

        var exports = {
            searchUsers: searchUsers,
            searchUsersAuto: searchUsersAuto,
            getUser: getUser,
            changeStatus: changeStatus,
            createUser: createUser,
            getUserCreationData: getUserCreationData,
            setUserCreationData: setUserCreationData,
            checkContactEmail: checkContactEmail,
            getOrderWorkflowProfiles: getOrderWorkflowProfiles,
            getWorkflowProfiles: getWorkflowProfiles,
            getWorkflowProfilesByUser: getWorkflowProfilesByUser,
            createImpersonatedUser: createImpersonatedUser,
        };

        return exports;

        ////////////////
        /**
         * Recherche des utilisateurs
         *
         * @param {Object} usersFilter - Critères de recherche
         */
        function searchUsers(usersFilter) {
            // Supprime les 'ALL' pour le role et le status (clone le filtre pour ne pas l'impacter)
            var filter = usersFilter.preparBeforeSearch();
            return KissUserDA.searchUsers(filter);
        }

        /**
         * Recherche des utilisateurs pour autocomplete
         *
         * @param value - valeur de recherche
         */
        function searchUsersAuto(value) {
            return KissUserDA.searchUsersAuto(value);
        }
        /**
         * Vérifie que l'adresse email n'est pas déjà utilisée
         * @param email - l'adresse email
         */
        function checkContactEmail(email) {
            return KissUserDA.checkContactEmail(email);
        }
        /**
         * Récupère un utilisateur
         *
         * @param {string} login - Identifiant de l'utilisateur
         */
        function getUser(login, sellerId) {
            return KissUserDA.getUser(login, sellerId);
        }

        /**
         * Permet de changer le status de l'utilisateur
         *
         * @param {User} user - l'utilisateur pour lequel on veut changer le status
         */
        function changeStatus(status, user) {
            return KissUserDA.changeStatus(status, user.login).then(function (data) {
                user.status = data.status;
            });
        }

        /**
         * Crée un nouvel utilisateur.
         */
        function createUser(seller, user) {
            return SellersDA.createUser(seller.id, user);
        }

        /**
         * Récupération des données de creation d'un nouvel utilisateur.
         */
        function getUserCreationData() {
            return _userCreationData;
        }

        /**
         * Ajout des données de creation d'un nouvel utilisateur.
         */
        function setUserCreationData(userBo) {
            return (_userCreationData = userBo);
        }

        /**
         * Récupération  des profils workflow
         */
        function getWorkflowProfiles(principalId) {
            return WorkflowDA.getProfiles(principalId);
        }

        /**
         * Récupération  des profils order workflow
         */
        function getOrderWorkflowProfiles(legalEntityId) {
            return WorkflowDA.getOrderWorkflowProfiles(legalEntityId);
        }

        /**
         * Récupération  des profils workflow par user
         */
        function getWorkflowProfilesByUser(userLogin) {
            return WorkflowDA.getWorkflowProfilesByUser(userLogin);
        }

        /**
         * creation d'un utilisateur temporaire.
         */
        function createImpersonatedUser(id) {
            return KissUserDA.createImpersonatedUser(id);
        }
    }
})();
